module.exports = __webpack_public_path__ + "static/media/back-icon.9b4b26ce.svg";